import { CurrentOrderActionType } from './actions';

export enum OrderStatus {
  Open = 'open',
  Processing = 'processing',
  Paid = 'paid',
  Failed = 'failed',
  Expired = 'expired',
  Cancelled = 'cancelled',
}

export enum OrderErrorType {
  UnrecognizedDevice = 'unrecognizedDevice',
  Unknown = 'unknown',
}

export interface Order {
  created_at: string;
  id: number;
  order_id: string;
  order_paid_at: string | null;
  order_status: OrderStatus;
  product_foreign_system: string;
  product_id: string;
}

export interface CurrentOrderState {
  order: Order | null;
  errorType: OrderErrorType | null;
}

export interface SetCurrentOrderAction {
  type: CurrentOrderActionType.setCurrentOrder;
  payload: Order;
}

export interface SetCurrentOrderErrorAction {
  type: CurrentOrderActionType.setCurrentOrderError;
  payload: OrderErrorType;
}

export interface ResetCurrentOrderErrorAction {
  type: CurrentOrderActionType.resetCurrentOrderError;
}

export interface ResetCurrentOrderAction {
  type: CurrentOrderActionType.resetCurrentOrder;
  payload: null;
}

export type CurrentOrderAction =
  | SetCurrentOrderAction
  | SetCurrentOrderErrorAction
  | ResetCurrentOrderErrorAction
  | ResetCurrentOrderAction;
